<div class="video-wrapper">
  <ng-container *ngIf="data.src&&data.ytVideoId&&data.ytVideoId!==''; then ytVideo">
  </ng-container>
  <ng-container *ngIf="data.src&&data.vimeoVideoId&&data.vimeoVideoId!==''; then vimeoVideo">
  </ng-container>
  <ng-container *ngIf="data.src && !(data.ytVideoId && data.ytVideoId !== '') && !(data.vimeoVideoId && data.vimeoVideoId !== ''); then urlVideo">
  </ng-container>
</div>

<ng-template #ytVideo>
  <youtube-player [videoId]="data.ytVideoId"
    suggestedQuality="highres"
    [width]=""
    [height]="100">
  </youtube-player>
</ng-template>

<ng-template #vimeoVideo>
  <vimeo-player [vimeoVideoId]="data.vimeoVideoId"></vimeo-player>
</ng-template>

<ng-template #urlVideo>
  <div class="mb-4 text-center" >
    <video controls>
      <source [src]="data.src">
    </video>
  </div>
</ng-template>
